import { Component, Input, OnInit } from '@angular/core';
import { TransportDetailsLayoutConverter } from '../../../../../../common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailLayout, TransportDetailMode } from '../../../../../../common/configuration/transport.configuration';
import { Transport } from '../../../../../../common/model/transport.model';
import { TransportDetailsLayoutService } from '../../../../../../components/transport-details/transport-details-layout.service';

@Component({
    selector: 'app-planned-assignment-details-list-entry',
    templateUrl: './planned-assignment-details-list-entry.component.html',
    styleUrls: ['./planned-assignment-details-list-entry.component.scss'],
    standalone: false
})
export class PlannedAssignmentDetailsListEntryComponent implements OnInit {

  TransportDetailMode = TransportDetailMode;
  layoutDefinition: TransportDetailLayout;

  @Input()
  transportDetails: Transport;

  constructor(
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter
  ) {

    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createStationAssignmentTransportDetailsGridLayout()
    );

  }

  ngOnInit(): void {
  }

}
